import { Loader } from "@googlemaps/js-api-loader";
import helpers from "../utils/helpers";

window.recaptchaContactOnloadCallback = function () {
  grecaptcha.render("contact-recaptcha", {
    sitekey: recaptcha_key,
    size: "invisible",
    badge: "inline",
    callback: templateContacts.challange,
  });
};

var dom_map = $("#map-wrap");
var contact_form = $("#contact-form");
const templateContacts = {
  init: function () {
    if (dom_map.length) {
      templateContacts.map.init();
    }
    if (contact_form.length) {
      contact_form.on("submit", function (e) {
        e.preventDefault();
        $(".error", this).removeClass("error");
        if (helpers.validate($(this))) {
          if (typeof gtag !== "undefined") {
            gtag("event", "conversion", {
              send_to: "AW-876185599/5QKQCJfsgJsYEP-P5qED",
            });
          }

          grecaptcha.execute();
        }
      });
    }
  },

  challange: function (token) {
    if (token) {
      templateContacts.submit(token);
    }
    grecaptcha.reset();
  },

  map: {
    lat: false,
    lng: false,
    pin: false,
    zoom: 16,

    init: function () {
      const loader = new Loader({
        apiKey: gmap_api_key,
        version: "weekly",
      });

      loader.load().then((google) => {
        templateContacts.map.render_map();
      });
    },
    render_map: function () {
      var self = this;

      if (dom_map.data("zoom")) {
        self.zoom = parseInt(dom_map.data("zoom"));
      }

      if (dom_map.data("pin")) {
        self.pin = dom_map.data("pin");
      }

      var map = new google.maps.Map(dom_map[0], {
        zoom: self.zoom,
        center: {
          lat: dom_map.data("lat"),
          lng: dom_map.data("lng"),
        },
        scrollwheel: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [{ color: "#ffffff" }, { lightness: 17 }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }, { lightness: 18 }],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }, { lightness: 16 }],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#dedede" }, { lightness: 21 }],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              { visibility: "on" },
              { color: "#ffffff" },
              { lightness: 16 },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              { saturation: 36 },
              { color: "#333333" },
              { lightness: 40 },
            ],
          },
          { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [{ color: "#fefefe" }, { lightness: 20 }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
          },
        ],
      });

      map.markers = [];

      var center = new google.maps.LatLng(
        dom_map.data("lat"),
        dom_map.data("lng")
      );
      var marker_options = {
        position: center,
        clickable: false,
        map: map,
        animation: google.maps.Animation.DROP,
      };
      if (self.pin) {
        marker_options.icon = self.pin;
      }
      var marker = new google.maps.Marker(marker_options);
      map.markers.push(marker);
    },
  },

  submit: function (token) {
    var form_data = {
      name: contact_form.find("#name").val(),
      surname: contact_form.find("#surname").val(),
      phone: contact_form.find("#phone").val(),
      email: contact_form.find("#email").val(),
      topic: contact_form.find("#topic").val(),
      message: contact_form.find("#message").val(),
    };
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "submit_cform",
        form_data: form_data,
        post_id: contact_form.find("#post-id").val(),
        contact_token: token,
        contact_nonce: contact_form.find("#contact-nonce").val(),
        contact_honey: contact_form.find("#contact-honey").val(),
      },
      beforeSend: function () {
        contact_form.addClass("loading");
        contact_form.find("button").addClass("loading");
        contact_form.find(".form__status").addClass("hidden");
      },
      success: function (response) {
        contact_form.removeClass("loading");
        contact_form.find("button").removeClass("loading");
        if (response.success) {
          // Send gtag event
          contact_form.find(".errors-wrap").remove();
          contact_form
            .find(".form__status")
            .removeClass("error")
            .text(response.data.message)
            .removeClass("hidden");
          contact_form[0].reset();
          grecaptcha.reset();
          contact_form.find("input, textarea").blur();
        } else {
          contact_form
            .find(".form__status")
            .addClass("error")
            .text(response.data.message)
            .removeClass("hidden");
        }
      },
    });
  },
};

export default templateContacts;
